export enum ProductPriceChangeOnPurchase {
  neverChange = 'NEVER_CHANGE',
  alwaysChange = 'ALWAYS_CHANGE',
  askBeforeChange = 'ASK_BEFORE_CHANGING',
}

export enum RegistrationsDefaultCode {
  manufacturerCode = 'MANUFACTURER_CODE',
  internalCode = 'INTERNAL_CODE',
  barCode = 'BARCODE',
  companyCode = 'COMPANY_CODE',
  sku = 'SKU',
}

export const RegistrationsDefaultCodeLabel = {
  [RegistrationsDefaultCode.manufacturerCode]: 'Cód. Fabricante',
  [RegistrationsDefaultCode.internalCode]: 'Cód. Interno',
  [RegistrationsDefaultCode.barCode]: 'Cód. Barras',
  [RegistrationsDefaultCode.companyCode]: 'Cód. Empresa',
  [RegistrationsDefaultCode.sku]: 'Cód. Interno',
};

export interface RegisterFormValues {
  cityId: number;
  street: string;
  cityName: string;
  district: string;
  state: string;
  cnpj: string;
  complement: string;
  number: string;
  zip: string;
  companyType: string;
  phone: string;
  name: string;
  contactName: string;
  email: string;
  login: string;
  password: string;
  passwordVerify: string;
}

export interface RegisterMatrix {
  company: {
    cnpj: string;
    companyAddress: {
      complement: string;
      district: string;
      cityId: number;
      cityName: string;
      number: string;
      street: string;
      zip: string;
    };
    companyType: string;
    contactList: Array<{
      active: boolean;
      contactType: string;
      value: string;
    }>;
    name: string;
  };
  matrixSettings?: {
    id: number;
    localizaCupom: string;
    localizaPartner: boolean;
    planAccountRegex: string;
    productPriceChangeOnPurchase: ProductPriceChangeOnPurchase;
    updateNcmAttributesOnExternalImports: boolean;
  };
  contactName: string;
  user: {
    email: string;
    login: string;
    password: string;
    passwordVerify: string;
  };
}

export interface AddressState {
  code: string;
  name: string;
}

export interface AddressCity {
  id: string;
  name: string;
}

export interface RegistrationFormValues {
  planAccountRegex: string;
}

export enum MatrixPartnerOrigin {
  NONE = 'NONE',
  BOSCH_CAR_SERVICE = 'BOSCH_CAR_SERVICE',
  BOSCH_MODULO = 'BOSCH_MODULO',
  SINDIREPA_NACIONAL = 'SINDIREPA_NACIONAL',
  TEST_BASE = 'TEST_BASE',
  EUROREPAR = 'EUROREPAR',
  PORTO_SEGURO_TEST_BASE = 'PORTO_SEGURO_TEST_BASE',
}

export interface MatrixSettings {
  active: boolean;
  creation: string;
  expiration: string;
  id: number;
  matrixSettings: {
    michelinSupplierId?: number;
    michelinIntegration: boolean;
    defaultPartApplication: boolean;
    defaultPartCode: RegistrationsDefaultCode;
    generateInvoiceDifferentCompanies: boolean;
    chartsOfAccountsPattern: string;
    id: number;
    localizaCupom: string;
    localizaPartner: boolean;
    passwordExpirationDays: number;
    planAccountRegex: string;
    productPriceChangeOnPurchase: ProductPriceChangeOnPurchase;
    updateNcmAttributesOnExternalImports: boolean;
    purchaseUseWorkOrderCost: boolean;
    shouldUpdateOriginOnPurchaseAuthorization: boolean;
    isDamageSelectedFirst: boolean;
    vehicleKmIsRequired: boolean;
    canViewMultipleCompaniesStockInDirectSale: boolean;
    shouldUpdateWorkOrderPartManufacturerAfterPurchase: boolean;
    shouldUpdateKmOnVehicle: boolean;
    isRegisteredInPlugStorage: boolean;
  };
  partnerOrigin: MatrixPartnerOrigin;
}

export interface UpdateMatrixSettingsRequest {
  id: number;
  matrixSettings: {
    id: number;
    localizaCupom?: string;
    localizaPartner?: boolean;
    planAccountRegex?: string;
    productPriceChangeOnPurchase?: ProductPriceChangeOnPurchase;
    passwordExpirationDays?: number;
    updateNcmAttributesOnExternalImports?: boolean;
    defaultPartApplication?: boolean;
    defaultPartCode?: RegistrationsDefaultCode;
    purchaseUseWorkOrderCost?: boolean;
    isDamageSelectedFirst?: boolean;
    vehicleKmIsRequired?: boolean;
    shouldUpdateKmOnVehicle?: boolean;
  };
}
